export const frontend = [
    {
        title: 'KAHT Beauty LV',
        description: "Used HTML, CSS and Javascript to build a static website for a Eyelash extension salon. KAHT Beauty LV is certified and have significant experience.",
        image: './images/kahtBeauty.png',
        tags: ['HTML', 'CSS (Sass)', 'Javascript'],
        source: 'https://kahtbeautylv.com',
        visit: 'https://kahtbeautylv.com',
        id: 0,
    },
    {
        title: 'Budget Tracker',
        description:"Built in React and Javascript while using react state management, context API, Local storage. Also, implement voice capability using Speechly voice interface API.",
        image: './images/budget.png',
        tags: ['React', 'JavaScript'],
        source: 'https://mybudgettracker.netlify.app/',
        visit: 'https://mybudgettracker.netlify.app/',
        id: 1,
    },
    {
        title: 'Asteroids Game',
        description: "This is a clone of one of the games that got me into gaming and design. Designed and built while learning HTML5 canvas and Javascript. Give it a try if you're bored.",
        image: './images/Asteroids.png',
        tags: ['HTML 5', 'Javascript'],
        source: 'https://drod702.com/asteroid',
        visit: 'https://drod702.com/asteroid',
        id: 2,
    },
    {
        title: 'Personal Portfolio',
        description: "This is my personal portfolio website to showcase my works as a Frontend Developer, Graphic Designer and CG Artist / Animator. UI was designed with Sketch.",
        image: './images/portfolio.png',
        tags: ['HTML', 'CSS', 'Javascript', 'React'],
        source: 'https://drod702.com',
        visit: 'https://drod702.com',
        id: 3,
    },
];